import axios from "@axios"

export const state = {
    campaignReports: {}
}

export const getters = {
    allCampaignReports: state => state.campaignReports
}

export const mutations = {
    GET_CAMPAIGN_REPORTS: (state, data) => {
        if (!data) {
            state.campaignReports = {}
            return false
        }
        state.campaignReports = data
    }
}

export const actions = {
    async getCampaignReports({ commit }) {
        await axios.get('/dashboard/campaign').then((resp) => {
            if (resp.status === 200) {

                commit('GET_CAMPAIGN_REPORTS', resp.data)
            }
        })
            .catch(() => {
                commit('GET_CAMPAIGN_REPORTS', null)
            })
    }
}